module.exports = __webpack_public_path__ + "static/media/cost.7f344385.svg";